import { useMutation } from '@tanstack/react-query';

import { downloadFromUrl } from '@/helpers/download';
import { mediaManagerClient } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { parseError } from '@/utils/axios';

export type TDownloadCNMCParams = {
  cnmcId: string;
};

export async function getCNMCDownload({ cnmcId }: TDownloadCNMCParams): Promise<{ url: string }> {
  return mediaManagerClient.get(`/api/v1/cnmcs/${cnmcId}/download`);
}

type MutationFn = typeof getCNMCDownload;

type TUseDownloadCNMCParams = {
  config?: MutationConfig<MutationFn>;
};

export function useDownloadCNMC({ config = {} }: TUseDownloadCNMCParams = {}) {
  const { addErrorNotification } = useNotificationStore();

  return useMutation({
    ...config,
    mutationFn: getCNMCDownload,
    onSuccess(response, variables, context) {
      downloadFromUrl(response.url);
      config.onSuccess?.(response, variables, context);
    },
    onError: error => {
      const { status } = parseError(error);
      if (status === 404) {
        addErrorNotification('El informe no existe');
      } else {
        addErrorNotification('Error al descargar el informe');
      }
    },
  });
}
